import Vue from "vue";
import Vuex from "vuex";
import Vue2TouchEvents from "vue2-touch-events";

export default function () {
  Vue.use(Vue2TouchEvents);
  Vue.use(Vuex);
}
